import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { actividadVulnerable } from '../model/catalogos/actividad-vulnerable.model';

import { SessionSotrageService } from 'src/services/session-sotrage.service';

export const selectorActividadVulnerableResolver: ResolveFn<actividadVulnerable[]> = (route, state) => {
  const catalogoService = inject(CatalogosService);  
  const storage = inject(SessionSotrageService);

  const currentSession = storage.getCurrentSession();

  if(currentSession?.actividadVulnerableId === null){
    return catalogoService.buscarActividadesVulnerables().pipe(
      map(res => res.isCorrect==='true' ?  res.data.info.result : []),
      catchError(()=> of([]))
    );
  }

  return catalogoService.buscarActividadesVulnerablesById(storage.getActividadVulnerable()).pipe(
    map(res => res.isCorrect==='true' ?  [res.data.info.result] : []),
    catchError(()=> of([]))
  );
};
